<template>
    <div class="room_view">
        <div>
            <div class="room_image_wrapper">
                <div class="room_image">
                    <div>
                        <img v-if="room_info.image_name" :src="`${root_path}room_image/${room_info.image_name}.jpg`" alt="room_image">
                        <img v-else :src="room_info.url" alt="room_image">
                    </div>
                    <div class="marks">
                        <div
                                class="mark"
                                v-for="(mark, i) in room_info.marks"
                                :key="i"
                                :style="{top: `${mark[1]}%`, left: `${mark[2]}%`}"
                        >
                            <RoomCheckMark :mark="mark"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tags">
                <RoomTag v-for="tag in filtered_tags" :tag="tag" :key="tag.id"/>
            </div>
        </div>
    </div>
</template>

<script>
    import AppPath from '../assets/js/AppPath'
    import RoomTag from '../components/RoomTag'
    import RoomCheckMark from '../components/RoomCheckMark'
    import imagesLoaded from 'imagesloaded'

    let room_image_el = null;
    let image_width = null;
    let image_height = null;
    let aspect_ratio = null;
    let is_vertical_image = false;

    export default {
        name: "RoomView",
        components: { RoomTag, RoomCheckMark },
        props: {
            room_info: Object,
            required: true
        },
        data: () => ({
            root_path: AppPath.root,
        }),
        mounted() {
            window.addEventListener('focus', this.adjustRoomElementSize);
            window.addEventListener('resize', this.adjustRoomElementSize);
            this.init();
        },
        beforeDestroy() {
            window.removeEventListener('focus', this.adjustRoomElementSize);
            window.removeEventListener('resize', this.adjustRoomElementSize);
        },
        methods: {
            adjustRoomElementSize() {
                if ( !room_image_el ) return;

                const this_width = this.$el.clientWidth;
                // this.$el.style.minHeight = `${this_width}px`;
                if ( is_vertical_image ) {
                    room_image_el.style.height = `${this_width}px`;
                    room_image_el.style.width = `${this_width * aspect_ratio}px`;
                }
                else {
                    room_image_el.style.height = `auto`;
                    room_image_el.style.width = `100%`;
                }
            },
            init() {
                imagesLoaded(this.$el, () => {
                    const image_el = this.$el.querySelector('.room_image img');
                    room_image_el = this.$el.querySelector('.room_image');
                    image_width = image_el.naturalWidth;
                    image_height = image_el.naturalHeight;
                    aspect_ratio = image_width / image_height;
                    is_vertical_image = image_el.naturalWidth < image_el.naturalHeight;
                    this.adjustRoomElementSize();
                });
            }
        },
        computed: {
            //写真下のタグは「見本帳」以外を表示
            filtered_tags: _this => {
                return _this.room_info.tags.filter(tag => tag.category !== 'sample_book');
            }
        },
    }
</script>

<style scoped lang="scss">
    .room_view {
        display: flex;
        justify-content: center;
        align-items: center;

        .room_image_wrapper{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 15px;
            .room_image{
                position: relative;
                img{
                    border-radius: 5px;
                    height: 100%;
                    width: 100%;
                    object-fit: contain;
                    vertical-align: middle;
                }
                .mark{
                    position: absolute;
                    top: 0;
                    left: 0;
                    transform: translate(-50%, -50%);
                }
            }
        }

        .tags{
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
        }

        @media screen and (max-width:639px) {
            .room_image_wrapper{
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 15px;
                .room_image{
                    position: relative;
                    width: initial!important;
                    height: initial!important;
                    max-height: 365px;
                    img{
                        border-radius: 5px;
                        width: 100%;
                        height: 100%;
                        max-height: 365px;
                        object-fit: contain;
                        vertical-align: middle;
                    }
                    .mark{
                        position: absolute;
                        top: 0;
                        left: 0;
                        transform: translate(-50%, -50%);
                    }
                }
            }
        }
    }
</style>
